import React, { useState, useEffect } from 'react';
import { Timer } from 'lucide-react';
import { Link } from './common/Link';

interface PromoBarProps {
  onClose: () => void;
}

export function PromoBar({ onClose }: PromoBarProps) {
  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    function calculateTimeUntilEndOfDay() {
      const now = new Date();
      const endOfDay = new Date(now);
      endOfDay.setHours(23, 59, 59, 999);
      return Math.floor((endOfDay.getTime() - now.getTime()) / 1000);
    }

    // Set initial time
    setTimeLeft(calculateTimeUntilEndOfDay());

    // Update every second
    const timer = setInterval(() => {
      const remaining = calculateTimeUntilEndOfDay();
      setTimeLeft(remaining);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor((timeLeft % 3600) / 60);
  const seconds = timeLeft % 60;

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-purple-gradient text-white py-2">
      <div className="max-w-7xl mx-auto px-4 flex items-center justify-center space-x-4">
        <Timer className="w-4 h-4 animate-pulse" />
        <p className="text-sm font-medium">
          Time's running out! ⏳ Save 83% and unlock unlimited tools now.
        </p>
        <div className="hidden sm:flex items-center space-x-2 text-sm font-medium">
          <span>Ends in:</span>
          <span className="bg-white/20 px-2 py-0.5 rounded">
            {hours.toString().padStart(2, '0')}:{minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
          </span>
        </div>
        <Link
          href="/pricing"
          className="hidden sm:block bg-white text-primary px-4 py-1 rounded-full text-sm hover:bg-white/90 transition-colors"
        >
          Get Deal
        </Link>
      </div>
    </div>
  );
}